import { createSlice } from "@reduxjs/toolkit";
import { getUserEmailId } from "../../api/apiToken";
import { isEmpty } from "../../constants/constants";

const initialState = {
   id: '',
   valid: false
}

let emailId = '';

const userSlice = createSlice({
   name: 'user',
   initialState,
   reducers: {
      addUser: (state, action) => {
         state.id = action.payload;
      },
      validUser: (state) => {
         getUserEmailId().then(userEmailId => emailId = userEmailId);
         if (isEmpty(state.id) || isEmpty(emailId)) state.valid = false
         else state.valid = state.id == emailId;
      },
      removeUser: (state) => {
         state.id = '';
         state.valid = false;
         emailId = '';
      }
   },
})


export const { addUser, removeUser, validUser } = userSlice.actions

export default userSlice.reducer
